export default "__VITE_ASSET__B4O$YY8m__"